import { configPromise } from '../config';
import * as Api from './api';
import { imageMimeTypeExtensions } from '../constants/mimeType';
import { preSignedUrlUploadService } from '../services/preSignedUrlUpload/PreSignedUrlUploadService';

class UploadApi {

  static TEMP_FILE_NAME = 'file';

  static generateTempFileName(file = {}) {
    const { type, name } = file;
    const fileExtension = imageMimeTypeExtensions.getExtension(type);
    const fileName = name ? name : UploadApi.TEMP_FILE_NAME;
    return `${fileName}.${fileExtension}`;
  }

  async uploadFile(file, progress, data, url = '/api/Avatars') {
    data = data || {};

    const config = await configPromise;

    if (!file.name) {
      file.name = UploadApi.generateTempFileName(file);
    }

    try {
      const response = await Api.postFile(config.cdnPath(url), [file], true, progress);
      return response;
    } catch (error) {
      throw error.res.error;
    }
  }

  async uploadFileWithPreSignedUrl(urlGetter, uploader, filenameSubmitter) {
    return preSignedUrlUploadService.upload(urlGetter, uploader, filenameSubmitter);
  }

  async uploadAvatar(data) {
    const config = await configPromise;
    return Api.post(config.apiPath('/api/Avatar'), data);
  }

  async uploadFileForHtmlEditor(file) {
    const config = await configPromise;
    const response = await this.uploadFile(file, () => {}, null, '/api/html-attachments');
    const body = response.body;
    body.url = config.cdnPath(body.content);
    return body;
  }

}


export default new UploadApi();
